/* Progressive enhancement only: layout and disclosure work without this script. */
if (!customElements.get('andcharlie-shop-area')) {
  customElements.define('andcharlie-shop-area', class extends HTMLElement {
    connectedCallback() {
      this.sidebar = this.querySelector('.ac-shop-area__sidebar-inner');
      if (!this.sidebar || !('ResizeObserver' in window)) return;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const inset = parseFloat(getComputedStyle(document.documentElement).fontSize) * 6;
          this.sidebar.classList.toggle('ac-shop-area__sidebar-inner--fits',
            this.sidebar.getBoundingClientRect().height <= window.innerHeight - inset);
        });
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.sidebar);
      window.addEventListener('resize', this.schedule);
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.schedule);
      cancelAnimationFrame(this.frame);
    }
  });
}
